import { withWizardRefetch } from "../withWizardRefetch.js";
import {
  useAddRecommendedTemplateMutation,
  useAddRecommendedTemplateTypeMutation,
  useModifyRecommendedTemplateMutation,
  useModifyRecommendedTemplateTypeMutation,
  useRecommendationsConfigQuestionControlForm_ModifyWizardSettingsMutation,
  useRemoveRecommendedTemplateMutation,
  useRemoveRecommendedTemplateTypeMutation,
} from "./RecommendationsConfigBox.generated.js";

export const useAddRecommendedTemplateMutationWithWizardRefetch =
  withWizardRefetch(useAddRecommendedTemplateMutation);

export const useAddRecommendedTemplateTypeMutationWithWizardRefetch =
  withWizardRefetch(useAddRecommendedTemplateTypeMutation);

export const useRemoveRecommendedTemplateMutationWithWizardRefetch =
  withWizardRefetch(useRemoveRecommendedTemplateMutation);

export const useRemoveRecommendedTemplateTypeMutationWithWizardRefetch =
  withWizardRefetch(useRemoveRecommendedTemplateTypeMutation);

export const useModifyRecommendedTemplateMutationWithWizardRefetch =
  withWizardRefetch(useModifyRecommendedTemplateMutation);

export const useModifyRecommendedTemplateTypeMutationWithWizardRefetch =
  withWizardRefetch(useModifyRecommendedTemplateTypeMutation);

export const useRecommendationsConfigQuestionControlForm_ModifyWizardSettingsMutationWithWizardRefetch =
  withWizardRefetch(
    useRecommendationsConfigQuestionControlForm_ModifyWizardSettingsMutation
  );
